
import AppClientHeadingSettings from "@/components/layout-editor/ClientHeadingSettings.vue";
import AppHeadingSettings from "@/components/layout-editor/HeadingSettings.vue";
import { DocumentLayoutClientHeading } from "@/utils/documents/layout-client-heading";
import { DocumentLayoutHeading } from "@/utils/documents/layout-heading";
import Vue from "vue";
import { SaleLayoutConf } from "@/models/sale-layout";
import { SaleService } from "@/services";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getSalePropSelectGroup } from "@/utils/prop-select/sale-to-prop-group";
import { SaleFreeBlock } from "@/utils/sale-layouts/sale-free-block";

export default Vue.extend({
	data() {
		return {
			tab: 0,
			selectedLanguage: "nl-be",
		};
	},
	props: {
		contactGroupId: Number,
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		},
		fullControl: Boolean
	},
	computed: {
		tabs(): string[] {
			let t = [
				this.$ct("heading"),
				this.$ct("clientAddress")
			];

			if(this.fullControl){
				t.push(this.$ct("deliveryAddress"));
			}

			return t.map(t => t.toString());
		},
		heading():DocumentLayoutHeading{
			return this.layout.Heading;
		},
		clientHeading():DocumentLayoutClientHeading{
			return this.layout.ClientHeading;
		},
		deliveryAddressHeading():DocumentLayoutClientHeading{
			return this.layout.DeliveryAddressHeading;
		},
		fields():PropSelectGroup{
			return getSalePropSelectGroup();
		}
	},
	methods: {
		async reset() {
			let confirm = await this.$wf.confirm(this.$ct("reset-to-defaults-confirm"), this.$t("common.yes"), this.$t("common.no"), this.$ct("common.warning"), "warning");
			if (confirm) {
				let saleLayout = new SaleLayoutConf();
				saleLayout.Data = await SaleService.getDefaultSaleLayout();
				for (let i = 1; i <= 9; i++) {
					(this as any).heading["Heading"+i].Style = (saleLayout as any).Data.Heading["Heading"+i].Style;
					(this as any).heading.X = (saleLayout as any).Data.Heading.X;
					(this as any).heading.Y = (saleLayout as any).Data.Heading.Y;
					(this as any).clientHeading["Property"+i] = (saleLayout as any).Data.ClientHeading["Property"+i];
					(this as any).clientHeading.X = (saleLayout as any).Data.ClientHeading.X;
					(this as any).clientHeading.Y = (saleLayout as any).Data.ClientHeading.Y;
					(this as any).deliveryAddressHeading["Property"+i] = (saleLayout as any).Data.DeliveryAddressHeading["Property"+i];
					(this as any).deliveryAddressHeading.X = (saleLayout as any).Data.DeliveryAddressHeading.X;
					(this as any).deliveryAddressHeading.Y = (saleLayout as any).Data.DeliveryAddressHeading.Y;
				}
				this.tab = 0;
			}
		},
		convertToFreeBlock(){
			let block = new SaleFreeBlock(this.layout.Heading.toFreeBlock().getJSON());
			this.layout.FreeBlocks.push(block);
			this.$emit("open-free-block", block);
		},
		convertClientToFreeBlock(heading:DocumentLayoutClientHeading, isDeliveryAddress:boolean){
			let block = new SaleFreeBlock(heading.toFreeBlock(isDeliveryAddress ? "DeliveryAddress" : "InvoiceAddress").getJSON());
			this.layout.FreeBlocks.push(block);
			this.$emit("open-free-block", block);
		}
	},
	components: {
		AppHeadingSettings,
		AppClientHeadingSettings,
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
